/*
 * This config is essentially just a wrapper for the env variables
 *
 */
const Config = {
  appVersion: '1.6.4',
  authEndpoint: process.env.REACT_APP_AUTH_ENDPOINT,
  liveGraphQLEndpoint: process.env.REACT_APP_LIVE_GRAPHQL_ENDPOINT,
  liveGraphQLSubscriptions: process.env.REACT_APP_LIVE_GRAPHQL_SUBSCRIPTIONS,
  middlewareApi: process.env.REACT_APP_API_SERVER_URL as string,
  initialOnloadDelay: process.env.REACT_APP_INITIAL_ONLOAD_DELAY,
  hotJarSiteId: process.env.REACT_APP_HOTJAR_SITE_ID,
  appProfile: process.env.REACT_APP_PROFILE,
  modelBaseURL: process.env.REACT_APP_MODEL_BASE_URL,
  metricDataWarning: process.env.REACT_APP_METRIC_DATA_WARNING,
  disable3DScene: process.env.REACT_APP_DISABLE_3D_SCENE,
  useLocalDgraph: !!parseInt(process.env.REACT_APP_USE_LOCAL_DGRAPH || '0'),
  auth0Domain: process.env.REACT_APP_AUTH0_DOMAIN,
  auth0Namespace: process.env.REACT_APP_AUTH0_NAMESPACE,
  auth0ClientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  auth0CallbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL,
  twinLabsAPIUrl: process.env.REACT_APP_API_SERVER_URL,
  // Base URL of the apps/twin deployment (hosts the public /legal/[slug] pages). twin-viewer
  // is a separate deployment and cannot link relatively. Unset -> the legal accept page keeps
  // linking to the marketing Webflow pages (dark-launch); set -> links use the new pages.
  twinAppBaseUrl: process.env.REACT_APP_TWIN_APP_BASE_URL,
  auth0Audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  // Public (pk.) Mapbox token. Preferred source; MapCanvas falls back to
  // the Auth0 claim, then '' (map hidden) when unset. Per-environment via Vercel.
  mapboxToken: process.env.REACT_APP_MAPBOX_TOKEN,
  // Base Mapbox style URL, per-environment via Vercel. Defaults to the current
  // production style so local dev and unset environments render unchanged.
  mapboxStyleUrl:
    process.env.REACT_APP_MAPBOX_STYLE_URL ||
    'mapbox://styles/twinlabsrob/clslxgt8e00nh01pf5tz9etu8',
};

export default Config;
